import React from "react";
import { SceneContainer, Scene } from "../styles/components/Global/Heading";

const LotusDisplay = () => {
  return (
    <SceneContainer id="lotus-display">
      <Scene className="scene" />
    </SceneContainer>
  );
};

export default LotusDisplay;
